import ItemList from './item-list';

export default ItemList;



// WEBPACK FOOTER //
// ./src/components/item-list/index.js